import React from 'react';

export default () => (
    <div>
            {/*<h1>Access denied</h1>*/}
    </div>
);
